<template>
  <Modal class="modal modal--mob u-text-center" :closable="false">
    <template #header>
      <h2 class="mb+"><strong>{{themeT('form_fields.interested_in_modal_label')}}</strong></h2>
      
    </template>
    <template #body>
        
        <ul class="list mb+">
            <li v-for="(e, i) in interests" :key="i">
                <div class="checkbox">
                  <input placeholder="meeting" name="interested_in" v-model="interested_in" type="checkbox" :id="`interest${i}`" :value="e.value"/>
                  <label :for="`interest${i}`">
                      {{ e.code === 'selling_pics' ? $t(`signup.new_registration.interests.${e.code}.${auth.user.gender === TYPE_GENDER_FEMALE ? 'sb' : 'sd'}`) : $t(`signup.new_registration.interests.${e.code}`)}}
                  </label>
                </div>
            </li>
        </ul>

        <button type="submit" :disabled="disableButton || working" @click="submit" class="button button--primary w-100 m0">
            {{$t('signup.new_registration.continue')}}
        </button>
    </template>
  </Modal>
</template>

<script>
import AuthenticatedMixin from "@/mixins/AuthenticatedMixin";
import Modal from "@/components/generic/Modal";
import { TYPE_GENDER_FEMALE } from "@/types/user";
import {updateProfile} from "@/service/user";
import {interests, additional_interests} from "@/service/forms";
import toastr from "toastr";
import ThemeMixin from "@/mixins/ThemeMixin";

export default {
  name: "PreActionInterestedIn",
  mixins: [AuthenticatedMixin, ThemeMixin],
  components: {Modal},
  data() {
    return {
      interests: [],
      working: false,
      interested_in: [],
    }
  },

  computed: {
      disableButton() {
          return this.interested_in.length === 0;
      }
  },

  methods: {

      async submit() {

        console.log(this.interested_in)

        this.working = true

        try {
          await updateProfile({interested_in: this.interested_in})
          toastr.success(this.$i18n.t('profile.edit.profile_changed'))
          this.working = false
          // pushDataLayer(GTM_EVENT_DATING_NET_WORTH_SUCCESS, this.auth.user)
          this.$emit('success')
        } catch {
          toastr.error(this.$i18n.t('credits.error_processing'))
          this.working = false
        }

      }
  },

  created() {
    this.TYPE_GENDER_FEMALE = TYPE_GENDER_FEMALE
    this.interests = [...interests, ...additional_interests]
  },
  // mounted() {
  //     if(this.payload.interested_in) {
  //         this.$refs.registrationForm.setFieldValue('interested_in', this.payload.interested_in)
  //     }
  // }
}
</script>

<style lang="scss" scoped>

.input-box {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  margin-bottom: 20px;

  input {
    font-size: 16px;
  }
}

label {
  text-align: left;
}

h2 {
  margin-bottom: 10px;
  letter-spacing: -0.9px;
  font-size: 20px;
  line-height: 1.1;
}

p {
  max-width: 320px;
  margin: 0 auto 30px;
  line-height: 24px;
}

button.button--primary {
  margin-top: 10px;
  margin-bottom: 10px;
}

.text-error {
  color: $color-type24;
  font-size: small;
}

.button {
    margin-top: 40px;
}

.list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 0;
}

.checkbox {

    label {
        padding: 0 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #000000;
        color: #000000;
        font-size: 16px;
        height: 36px;
        border-radius: 18px;
        font-weight: 600;
        font-family: "Open Sans", sans-serif;
        cursor: pointer;
        transition: all .3s ease;
        background-color: transparent;
        text-transform: capitalize;
    }

    input:checked + label {
        color: #fff;
        background-color: #000000;
    }
}
</style>
